import app from '../main'
import * as types from './types'
import axios from 'axios'
import constant from '@/constants'

export default {
  [types.SET_LANG](state, payload) {
    app.$i18n.locale = payload
    axios.defaults.headers.common['Lang'] = payload
    state.lang = payload
  },
  setCategoryUuid(state, categoryUuid) {
    state.category_uuid = categoryUuid
  },
  setSubCategoryUuid(state, subCategoryUuid) {
    state.sub_category_uuid = subCategoryUuid
  },
  [types.SET_SELECTED_PRODUCT](state, product) {
    state.selectedProduct = product
  },
  setSelectedOrderTime(state, orderTime) {
    state.selectedOrderTime = orderTime
  },
  [types.SET_CATEGORY_LIST](state, payload) {
    state.categoryList = payload
  },
  [types.SET_TRIGGER_CHOOSING_TOPPING](state, payload) {
    state.shouldTriggerChoosingTopping = true
  },
  [types.SET_IS_VALID_ORDER_TIME](state, isValid) {
    state.isValidOrderTime = isValid
  },
  [types.SET_SELECTED_CART](state, product) {
    state.selectedCart = product
  },
  [types.SET_USER](state, user) {
    state.user = user
  },
  [types.SET_SELECTED_CATEGORY](state, category) {
    state.selectedCategory = category
  },
  [types.SET_ATTRIBUTES_LIST](state, payload) {
    state.attributeList = payload
  },
  [types.SET_ATTRIBUTES_FILTER](state, payload) {
    state.attributeFilter = payload
  },
  [types.SET_SELECTED_SUB_CATEGORY](state, subCategory) {
    state.selectedSubCategory = subCategory
  },
  [types.SET_SELECTED_OUTLET](state, payload) {
    state.selectedOutlet = payload
  },
  [types.SET_HUT_OUTLET_ID](state, payload) {
    state.selectedHutOutletId = payload
  },
  [types.SET_SELECTED_HUT_OUTLET](state, payload) {
    state.selectedHutOutlet = payload
  },
  [types.SET_DISPOSITION](state, payload) {
    state.selectedDisposition = payload
  },
  [types.SET_PAYMENT_STATUS](state, payload) {
    state.paymentStatus = payload
  },
  [types.SET_SIDEBAR_OPEN](state, payload) {
    if (payload != null){
      state.sidebarOpen = payload
    }else{
      state.sidebarOpen = !state.sidebarOpen
    }

    let body = document.body
    if(state.sidebarOpen){
      body.classList.add('toggle')
    }else{
      body.classList.remove('toggle')
    }
  },
  [types.SET_HOME_SIDEBAR_OPEN] (state, payload) {
    if (payload != null) {
      state.homeSidebarOpen = payload
    } else {
      state.homeSidebarOpen = !state.homeSidebarOpen
    }

    let body = document.body
    if (state.homeSidebarOpen) {
      body.classList.add('toggle')
    } else {
      body.classList.remove('toggle')
    }
  },
  setCouponMessage(state, message) {
    state.coupon_message = message
  },
  setMenuDeal(state, menuDeal) {
    state.menu_deal = menuDeal
  },
  [types.SET_SELECTED_SIZE] (state, payload) {
    state.selectedSizeCrust.size = payload
  },
  [types.SET_SELECTED_CRUST] (state, payload) {
    state.selectedSizeCrust.crust = payload
  },
  [types.REMOVE_SELECTED_SIZE_N_CRUST] (state, payload) {
    state.selectedSizeCrust = {}
  },
  [types.SET_EXTRA_TOPPINGS] (state, payload) {
    state.extraToppings = payload
  },
  [types.SET_DEFAULT_TOPPINGS] (state, payload) {
    state.defaultToppings = payload
  },
  [types.UPDATE_QUANTITY_EXTRA_TOPPINGS] (state, payload) {
    let extraToppings = JSON.parse(JSON.stringify(state.extraToppings))
    const {uuid, action} = payload

    extraToppings.map(item => {
      // find & update count for topping
      if (item.uuid === uuid) {
        if (action === constant.TOPPING.EXTRA.ADD) {
          item.count++
        } else if (action === constant.TOPPING.EXTRA.REMOVE) {
          item.count--
        }
      }

      return item
    })

    state.extraToppings = extraToppings
  },
  [types.ADD_SELECTED_EXTRA_TOPPING] (state, payload) {
    state.addedExtraToppings.push(payload)
  },
  [types.REMOVE_SELECTED_EXTRA_TOPPING] (state, payload) {
    let addedExtraToppings = JSON.parse(JSON.stringify(state.addedExtraToppings))

    // find and delete the 1st found item
    const iToppingWillBeRemoved = addedExtraToppings.findIndex(item => item.uuid === payload.uuid)
    if (iToppingWillBeRemoved >= 0) {
      addedExtraToppings.splice(iToppingWillBeRemoved, 1)
    }

    state.addedExtraToppings = addedExtraToppings
  },
  [types.RESET_ADDED_EXTRA_TOPPINGS] (state, payload) {
    state.addedExtraToppings = []
  },
  [types.UPDATE_QUANTITY_DEFAULT_TOPPINGS] (state, payload) {
    let defaultToppings = JSON.parse(JSON.stringify(state.defaultToppings))
    const {uuid, action} = payload

    defaultToppings.map(item => {
      // find & update count for topping
      if (item.uuid === uuid) {
        if (action === constant.TOPPING.DEFAULT.REMOVE) {
          item.count--
        } else if (action === constant.TOPPING.DEFAULT.READD) {
          item.count++
        }
      }

      return item
    })

    state.defaultToppings = defaultToppings
  },
  [types.REMOVE_SELECTED_DEFAULT_TOPPING] (state, payload) {
    state.removedDefaultToppings.push(payload)
  },
  [types.RE_ADD_SELECTED_DEFAULT_TOPPING] (state, payload) {
    let removedDefaultToppings = JSON.parse(JSON.stringify(state.removedDefaultToppings))

    // find and delete the 1st found item
    const iToppingWillBeAdded = removedDefaultToppings.findIndex(item => item.uuid === payload.uuid)
    if (iToppingWillBeAdded >= 0) {
      removedDefaultToppings.splice(iToppingWillBeAdded, 1)
    }

    state.removedDefaultToppings = removedDefaultToppings
  },
  [types.RESET_REMOVED_DEFAULT_TOPPINGS] (state, payload) {
    state.removedDefaultToppings = []
  },
  [types.RESET_QUANTITY_TOPPINGS] (state, payload) {
    let defaultToppings = JSON.parse(JSON.stringify(state.defaultToppings))
    let extraToppings = JSON.parse(JSON.stringify(state.extraToppings))

    defaultToppings.map(item => {
      return item.count = constant.TOPPING.DEFAULT_TOPPING_COUNT
    })

    extraToppings.map(item => {
      return item.count = constant.TOPPING.EXTRA_TOPPING_COUNT
    })

    state.defaultToppings = defaultToppings
    state.extraToppings = extraToppings
  },


  /**
   * HH
   * */
  [types.SET_SELECTED_HH_SIZE] (state, payload) {
    state.hhSelectedSizeCrust.size = payload
  },
  [types.SET_SELECTED_HH_CRUST] (state, payload) {
    state.hhSelectedSizeCrust.crust = payload
  },
  [types.REMOVE_SELECTED_HH_SIZE_N_CRUST] (state, payload) {
    state.hhSelectedSizeCrust.size = {}
    state.hhSelectedSizeCrust.crust = {}
  },
  [types.SET_HH_SIZES] (state, payload) {
    state.hhSizes = payload
  },
  [types.SET_HH_CRUSTES] (state, payload) {
    state.hhCrustes = payload
  },
  [types.SET_HH_PIZZA_LIST] (state, payload) {
    state.hhPizzaList = payload
  },

  // LEFT pizza
  [types.SET_LEFT_PIZZA] (state, payload) {
    state.hhLeftPizza = payload
  },
    // *** LEFT TOPPINGs
  [types.SET_LEFT_EXTRA_TOPPINGS] (state, payload) {
    state.pzzLeftExtraToppings = payload
  },
  [types.SET_LEFT_DEFAULT_TOPPINGS] (state, payload) {
    state.pzzLeftDefaultToppings = payload
  },
  [types.ADD_LEFT_SELECTED_EXTRA_TOPPING] (state, payload) {
    state.pzzLeftAddedExtraToppings.push(payload)
  },
  [types.REMOVE_LEFT_SELECTED_EXTRA_TOPPING] (state, payload) {
    let addedExtraToppings = JSON.parse(JSON.stringify(state.pzzLeftAddedExtraToppings))

    // find and delete the 1st found item
    const iToppingWillBeRemoved = addedExtraToppings.findIndex(item => item.uuid === payload.uuid)
    if (iToppingWillBeRemoved >= 0) {
      addedExtraToppings.splice(iToppingWillBeRemoved, 1)
    }

    state.pzzLeftAddedExtraToppings = addedExtraToppings
  },
  [types.RESET_LEFT_ADDED_EXTRA_TOPPINGS] (state, payload) {
    state.pzzLeftAddedExtraToppings = []
  },
  [types.UPDATE_QUANTITY_LEFT_EXTRA_TOPPINGS] (state, payload) {
    let extraToppings = JSON.parse(JSON.stringify(state.pzzLeftExtraToppings))
    const {uuid, action} = payload

    extraToppings.map(item => {
      // find & update count for topping
      if (item.uuid === uuid) {
        if (action === constant.TOPPING.EXTRA.ADD) {
          item.count++
        } else if (action === constant.TOPPING.EXTRA.REMOVE) {
          item.count--
        }
      }

      return item
    })

    state.pzzLeftExtraToppings = extraToppings
  },
  [types.UPDATE_QUANTITY_LEFT_DEFAULT_TOPPINGS] (state, payload) {
    let defaultToppings = JSON.parse(JSON.stringify(state.pzzLeftDefaultToppings))
    const {uuid, action} = payload

    defaultToppings.map(item => {
      // find & update count for topping
      if (item.uuid === uuid) {
        if (action === constant.TOPPING.DEFAULT.REMOVE) {
          item.count--
        } else if (action === constant.TOPPING.DEFAULT.READD) {
          item.count++
        }
      }

      return item
    })

    state.pzzLeftDefaultToppings = defaultToppings
  },
  [types.REMOVE_LEFT_SELECTED_DEFAULT_TOPPING] (state, payload) {
    state.pzzLeftRemovedDefaultToppings.push(payload)
  },
  [types.RE_ADD_LEFT_SELECTED_DEFAULT_TOPPING] (state, payload) {
    let removedDefaultToppings = JSON.parse(JSON.stringify(state.pzzLeftRemovedDefaultToppings))

    // find and delete the 1st found item
    const iToppingWillBeAdded = removedDefaultToppings.findIndex(item => item.uuid === payload.uuid)
    if (iToppingWillBeAdded >= 0) {
      removedDefaultToppings.splice(iToppingWillBeAdded, 1)
    }

    state.pzzLeftRemovedDefaultToppings = removedDefaultToppings
  },
  [types.RESET_LEFT_REMOVED_DEFAULT_TOPPINGS] (state, payload) {
    state.pzzLeftRemovedDefaultToppings = []
  },
  [types.RESET_QUANTITY_LEFT_TOPPINGS] (state, payload) {
    let defaultToppings = JSON.parse(JSON.stringify(state.pzzLeftDefaultToppings))
    let extraToppings = JSON.parse(JSON.stringify(state.pzzLeftExtraToppings))

    defaultToppings.map(item => {
      return item.count = constant.TOPPING.DEFAULT_TOPPING_COUNT
    })

    extraToppings.map(item => {
      return item.count = constant.TOPPING.EXTRA_TOPPING_COUNT
    })

    state.pzzLeftDefaultToppings = defaultToppings
    state.pzzLeftExtraToppings = extraToppings
  },
  [types.RESET_LEFT_TOPPINGS] (state, payload) {
    state.pzzLeftExtraToppings = []
    state.pzzLeftDefaultToppings = []
  },


  // RIGHT pizza
  [types.SET_RIGHT_PIZZA] (state, payload) {
    state.hhRightPizza = payload
  },
  // *** RIGHT toppings
  [types.SET_RIGHT_EXTRA_TOPPINGS] (state, payload) {
    state.pzzRightExtraToppings = payload
  },
  [types.SET_RIGHT_DEFAULT_TOPPINGS] (state, payload) {
    state.pzzRightDefaultToppings = payload
  },
  [types.ADD_RIGHT_SELECTED_EXTRA_TOPPING] (state, payload) {
    state.pzzRightAddedExtraToppings.push(payload)
  },
  [types.REMOVE_RIGHT_SELECTED_EXTRA_TOPPING] (state, payload) {
    let addedExtraToppings = JSON.parse(JSON.stringify(state.pzzRightAddedExtraToppings))

    // find and delete the 1st found item
    const iToppingWillBeRemoved = addedExtraToppings.findIndex(item => item.uuid === payload.uuid)
    if (iToppingWillBeRemoved >= 0) {
      addedExtraToppings.splice(iToppingWillBeRemoved, 1)
    }

    state.pzzRightAddedExtraToppings = addedExtraToppings
  },
  [types.RESET_RIGHT_ADDED_EXTRA_TOPPINGS] (state, payload) {
    state.pzzRightAddedExtraToppings = []
  },
  [types.UPDATE_QUANTITY_RIGHT_EXTRA_TOPPINGS] (state, payload) {
    let extraToppings = JSON.parse(JSON.stringify(state.pzzRightExtraToppings))
    const {uuid, action} = payload

    extraToppings.map(item => {
      // find & update count for topping
      if (item.uuid === uuid) {
        if (action === constant.TOPPING.EXTRA.ADD) {
          item.count++
        } else if (action === constant.TOPPING.EXTRA.REMOVE) {
          item.count--
        }
      }

      return item
    })

    state.pzzRightExtraToppings = extraToppings
  },
  [types.UPDATE_QUANTITY_RIGHT_DEFAULT_TOPPINGS] (state, payload) {
    let defaultToppings = JSON.parse(JSON.stringify(state.pzzRightDefaultToppings))
    const {uuid, action} = payload

    defaultToppings.map(item => {
      // find & update count for topping
      if (item.uuid === uuid) {
        if (action === constant.TOPPING.DEFAULT.REMOVE) {
          item.count--
        } else if (action === constant.TOPPING.DEFAULT.READD) {
          item.count++
        }
      }

      return item
    })

    state.pzzRightDefaultToppings = defaultToppings
  },
  [types.REMOVE_RIGHT_SELECTED_DEFAULT_TOPPING] (state, payload) {
    state.pzzRightRemovedDefaultToppings.push(payload)
  },
  [types.RE_ADD_RIGHT_SELECTED_DEFAULT_TOPPING] (state, payload) {
    let removedDefaultToppings = JSON.parse(JSON.stringify(state.pzzRightRemovedDefaultToppings))

    // find and delete the 1st found item
    const iToppingWillBeAdded = removedDefaultToppings.findIndex(item => item.uuid === payload.uuid)
    if (iToppingWillBeAdded >= 0) {
      removedDefaultToppings.splice(iToppingWillBeAdded, 1)
    }

    state.pzzRightRemovedDefaultToppings = removedDefaultToppings
  },
  [types.RESET_RIGHT_REMOVED_DEFAULT_TOPPINGS] (state, payload) {
    state.pzzRightRemovedDefaultToppings = []
  },
  [types.RESET_QUANTITY_RIGHT_TOPPINGS] (state, payload) {
    let defaultToppings = JSON.parse(JSON.stringify(state.pzzRightDefaultToppings))
    let extraToppings = JSON.parse(JSON.stringify(state.pzzRightExtraToppings))

    defaultToppings.map(item => {
      return item.count = constant.TOPPING.DEFAULT_TOPPING_COUNT
    })

    extraToppings.map(item => {
      return item.count = constant.TOPPING.EXTRA_TOPPING_COUNT
    })

    state.pzzRightDefaultToppings = defaultToppings
    state.pzzRightExtraToppings = extraToppings
  },
  [types.RESET_RIGHT_TOPPINGS] (state, payload) {
    state.pzzRightExtraToppings = []
    state.pzzRightDefaultToppings = []
  },
  [types.SET_SHOW_MODAL_TAKE_AWAY_LESS](state, flag) {
    state.showModalTakeAwayLess = flag
  },
  [types.SET_HUT_REWARD] (state, payload) {
    state.hutReward = payload
  },
  [types.SET_MAINTAINANCE_HUT_REWARD] (state, payload) {
    state.maintainanceHutReward = payload
  },
  [types.SET_SLICES_REWARD] (state, payload) {
    state.slicesReward = payload
  }
}



// WEBPACK FOOTER //
// ./src/store/mutations.js